import styled from "@emotion/styled";

export const LoadingContainer = styled.div({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  minHeight: "400px",
  width: "100%",
});
